import axios from "axios";

const endpoint = `${process.env.REACT_APP_API_URL}/smq/Historique`;

const HistoriqueService = {
  async getActionHistory(planActionId, page = 1, pageSize = 25) {
    try {
      const response = await axios.get(endpoint, {
        params: {
          page,
          page_size: pageSize,
          table_id: planActionId,
          table_name: "nc_plan_action",
        },
      });
      const payload = response?.data;
      if (payload?.status === false || !payload?.data) {
        throw new Error("Invalid history response");
      }
      return payload.data;
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        console.error("Unable to load corrective action history", error);
      }
      throw new Error(
        "Une erreur s’est produite lors de la récupération de l’historique."
      );
    }
  },
};

export default HistoriqueService;
